import { FC } from "react"
import { LeadLogStat } from "../../../../../../types"
import { useGetIntegrationDetailsQuery } from "../../../../../../redux/queries"
import TdInfoCell from "../../../../table/cells/td-info-cell"

interface LeadSourceCellProps {
  info: LeadLogStat
}

const LeadSourceCell: FC<LeadSourceCellProps> = ({ info }) => {
  const { source, source_id, integ_title } = info

  // Fast path: use integ_title if available
  const shouldFetch = !integ_title && source_id

  const { data: integration } = useGetIntegrationDetailsQuery(
    String(source_id),
    { skip: !shouldFetch }
  )

  // Resolution order: integ_title > integration.title > source
  const displayText = integ_title || integration?.title || source || "-"

  return (
    <TdInfoCell
      info={displayText}
      customContainerClass="p-3 md:p-5 align-top"
      customTextClass="whitespace-pre-wrap break-words leading-6"
    />
  )
}

export default LeadSourceCell
